var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 7.29009C35.9539 7.22557 36.0461 7.22557 36.0593 7.29009C36.7438 10.6391 39.361 13.2562 42.71 13.9408C42.7745 13.9539 42.7745 14.0461 42.71 14.0593C39.361 14.7438 36.7438 17.361 36.0593 20.71C36.0461 20.7745 35.9539 20.7745 35.9408 20.71C35.2562 17.361 32.6391 14.7438 29.2901 14.0593C29.2256 14.0461 29.2256 13.9539 29.2901 13.9408C32.6391 13.2562 35.2562 10.6391 35.9408 7.29009Z",
    stroke: "#B3FF10",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23.5002V26.4655C41 28.4958 41 29.511 40.7362 30.4445C40.5026 31.2712 40.1188 32.048 39.6039 32.7358C39.0227 33.5123 38.2162 34.129 36.6034 35.3623L31.7754 39.0544C28.991 41.1836 27.5988 42.2482 26.0654 42.658C24.7122 43.0196 23.2878 43.0196 21.9346 42.658C20.4012 42.2482 19.009 41.1836 16.2246 39.0544L11.3966 35.3623C9.78374 34.129 8.97733 33.5123 8.39607 32.7358C7.88121 32.048 7.49738 31.2712 7.26376 30.4445C7 29.511 7 28.4958 7 26.4655V18.9244C7 16.0714 7 14.6449 7.47232 13.4251C7.88949 12.3478 8.56679 11.3905 9.44384 10.6386C10.4368 9.78724 11.782 9.31246 14.4724 8.36291L19.7399 6.5038C21.3186 5.94661 22.108 5.66801 22.9176 5.55745C23.6359 5.45937 24.3641 5.45937 25.0824 5.55745C25.892 5.66801 26.6814 5.94661 28.2601 6.5038L29.5 6.94141",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9375 18.5871C24.729 17.5667 23.271 17.5667 23.0624 18.5871C22.6018 20.8407 20.8406 22.6019 18.587 23.0626C17.5666 23.2711 17.5666 24.7291 18.587 24.9376C20.8406 25.3983 22.6018 27.1595 23.0624 29.4131C23.271 30.4335 24.729 30.4335 24.9375 29.4131C25.3982 27.1595 27.1594 25.3983 29.413 24.9376C30.4334 24.7291 30.4334 23.2711 29.413 23.0626C27.1594 22.6019 25.3982 20.8407 24.9375 18.5871Z",
    fill: "#B3FF10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.5288b32249bfb5934b1ba9854913d50e.svg";
export { ForwardRef as ReactComponent };